module.exports = __webpack_public_path__ + "img/OAS_HandPaintedRunicSword_Blue_Pref.b4e1445b.png";